import React, { useState, useEffect } from 'react';

function InstagramTest() {
    const [embedHtml, setEmbedHtml] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEmbed = async () => {
            try {
                const response = await fetch(
                    `https://graph.facebook.com/v19.0/instagram_oembed?url=https://www.instagram.com/p/DKuo76WMEG9/&access_token=3081374225370052|7b1d12c6fba07e5ec88fa4844839659b`
                );
                if (!response.ok) throw new Error('Network response was not ok');

                const data = await response.json();
                setEmbedHtml(data.html);
            } catch (err) {
                console.error('Error fetching oEmbed:', err);
                setError(err.message);
            }
        };

        fetchEmbed();
    }, []);

    return (
        <div style={{ padding: '2rem' }}>
            <h1>Instagram oEmbed Test</h1>
            {error && <p style={{ color: 'red' }}>Error: {error}</p>}
            {embedHtml ? (
                <div
                    className="instagram-embed"
                    dangerouslySetInnerHTML={{ __html: embedHtml }}
                />
            ) : (
                <p>Loading embed...</p>
            )}
        </div>
    );
}

export default InstagramTest;
